export default "__VITE_ASSET__CKEzVpR5__"